/**
 * Cursor CMD+P-style compact match: separators in the haystack do not block a
 * contiguous typed needle. `/setupsou` matches `setup-soul`.
 *
 * Dashes, underscores, spaces, and dots are stripped from both sides; then
 * substring match. Original lowercase includes still counts.
 */
const COMPACT_SEPARATORS = /[-_\s.]+/g

export function compactSearchKey(value: string): string {
  return value.trim().toLowerCase().replace(COMPACT_SEPARATORS, '')
}

export function compactSearchMatch(haystack: string, needle: string): boolean {
  const rawNeedle = needle.trim().toLowerCase()
  if (!rawNeedle) return true
  const rawHay = haystack.toLowerCase()
  if (rawHay.includes(rawNeedle)) return true
  const compactHay = compactSearchKey(haystack)
  const compactNeedle = compactSearchKey(needle)
  if (!compactNeedle) return true
  return compactHay.includes(compactNeedle)
}

/** Slash skill row fields used for filtering (id is the /tag). */
export type SlashSkillMatchInput = {
  id: string
  name: string
  description: string
  triggerKeywords?: string[]
}

/** Cursor-style compact match on skill id (the /tag), name, description, keywords. */
export function skillMatchesSlashQuery(skill: SlashSkillMatchInput, query: string): boolean {
  const q = query.trim().replace(/^\//, '').toLowerCase()
  if (!q) return true
  if (compactSearchMatch(skill.name, q)) return true
  if (compactSearchMatch(skill.id, q)) return true
  if (compactSearchMatch(skill.description, q)) return true
  return (skill.triggerKeywords ?? []).some((kw) => {
    const normalized = String(kw).replace(/^\//, '')
    return compactSearchMatch(normalized, q) || compactSearchMatch(q, normalized)
  })
}
